import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'
import { CarrierAvailabilityResponse } from '@types'
import { OtherUtils } from '@utils'

import { getCarrierAvailability } from '../api'

const useGetCarrierAvailability = () => {
  const { data, isLoading, refetch } = useQuery<CarrierAvailabilityResponse>(
    [QUERY_KEYS.CARRIER_AVAILABILITY],
    getCarrierAvailability,
    {
      onError: OtherUtils.onErrorHandler,
      staleTime: Infinity,
    },
  )

  return {
    refetchCarrierAvailabilityData: refetch,
    carrierAvailabilityData: data,
    carrierAvailabilityDataIsLoading: isLoading,
  }
}

export { useGetCarrierAvailability }
